import RightsForm from './RightsForm';

export default RightsForm;
